module.exports = __webpack_public_path__ + "static/img/about_card04.6ae59c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/about_card04.png
// module id = 4lxm
// module chunks = 2